export interface ContentEmptyStateProps {
  title: string;
  body: string;
  className?: string;
}

export function ContentEmptyState({
  title,
  body,
  className,
}: ContentEmptyStateProps) {
  return (
    <div
      role="status"
      className={
        className ??
        "flex flex-col items-center gap-3 rounded-lg border border-dashed bg-background p-6 text-center"
      }
    >
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="text-sm text-muted-foreground">{body}</p>
    </div>
  );
}
